
import React, { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";

function StudentOverview(props) {
  const { student } = props;

  if (Object.keys(student).length === 0) {
    return;
  }

  const [resume, setResume] = useState(null);

  useEffect(() => {
    // Get student's resume from backend
    const body = new FormData();
    body.append("resumeFileName", student.resumeFileName);
    axios.post("/student/getResume", body, { responseType: "blob" }).then((res) => {
      const blob = new Blob([res.data], { type: "application/pdf" });
      setResume(URL.createObjectURL(blob));
    });
  }, [student]);

  return (
    <div className="StudentOverview-container rounded-xl bg-white px-6 py-4 flex flex-col h-full">
      <div className="StudentOverview-title text-4xl font-bold mb-4  font-brand-primary flex">
        {student.firstName} {student.lastName}
      </div>
      <div className="StudentOverview-infoContainer flex flex-col text-lg font-brand-primary">
        <div className="StudentOverview-infoHeader flex font-bold">Bio:</div>
        <div className="StudentOverview-info flex mb-4">{student.bio}</div>
      </div>

      <iframe className="StudentOverview-resume h-full" src={resume} />
    </div>
  );
}

StudentOverview.propTypes = {
  student: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    academicYear: PropTypes.string,
    csType: PropTypes.string,
    bio: PropTypes.string,
    gitHubURL: PropTypes.string,
    graduationYear: PropTypes.string,
    linkedInURL: PropTypes.string,
    resumeFileName: PropTypes.string,
    websiteURL: PropTypes.string,
    emailNotif: PropTypes.number,
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobType: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
  }),
};

StudentOverview.defaultProps = {
  student: {},
};

export default StudentOverview;
